"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _router = require("@reach/router");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _antd = require("antd");

var _PreviewEditor = _interopRequireDefault(require("../editor/PreviewEditor"));

var _Loader = _interopRequireDefault(require("../Loader"));

var _redux = require("../../redux");

var _templateObject;

var PreviewRouter = function PreviewRouter(props) {
  var _ref = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      siteLoaded = _ref.cms.siteLoaded;

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, siteLoaded ? /*#__PURE__*/_react.default.createElement(_router.Router, null, /*#__PURE__*/_react.default.createElement(_PreviewEditor.default, (0, _extends2.default)({
    path: '*'
  }, props))) : /*#__PURE__*/_react.default.createElement(_Loader.default, {
    text: "Load Preview"
  }), /*#__PURE__*/_react.default.createElement(PreviewBanner, {
    children: "Preview",
    type: "primary"
  }));
};

var PreviewBanner = (0, _styledComponents.default)(_antd.Button)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: fixed;\n  left: 0;\n  top: 50%;\n  z-index: 9999;\n  transform: rotate(270deg) translate(-50%, 50%);\n  transform-origin: left;\n  font-size: 14px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n    'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n    'Noto Color Emoji';\n"])));
var _default = PreviewRouter;
exports.default = _default;